import React from 'react';
import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';



const Contact = (props) => {
  return (
    <div style={{backgroundImage:  "url(https://images.pexels.com/photos/129731/pexels-photo-129731.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260)", height:'100vh' }  }>
      <div className="ml-5 mr-5 p-5 pt-0 mt-0 bg-light text-dark "  > 
      <h1>Contact Us</h1>
      <h5>Please fill out the form below we will contact you soon</h5>
      <Form>
      <FormGroup>
        <Label for="exampleEmail">Email</Label>
        <Input type="email" name="email" id="exampleEmail" placeholder="your email" required />

      </FormGroup>
      <FormGroup>
        <Label for="exampleName">Name</Label>
        <Input type="text" name="name" id="exampleName" placeholder="your name" required/>
      </FormGroup>
      
      <FormGroup>
        <Label for="exampleText">Message</Label>
        <Input type="textarea" name="text" id="exampleText" required/>
      </FormGroup>
      
      
       
      <FormGroup check>
        <Label check>
          <Input type="checkbox" required/>{' '}
          I agree to all the terms and conditions applies.
        </Label>
      </FormGroup>
      <Button className="mt-3">Submit</Button>
    </Form>
    </div>
    </div>
  );
}

export default Contact;